"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInsuranceTodoItemsStatus = void 0;
var _constants = require("./constants");
var _insurance = require("./insurance.utils");
var isIneligibleBannerVisible = _insurance.InsuranceUtil.isIneligibleBannerVisible;
var getInsuranceTodoItemsStatus = function getInsuranceTodoItemsStatus(submission, activeCard) {
  var flowReq = submission.flow;
  var flow = flowReq.data;
  var hasActiveInsurance = !!activeCard;
  var card = flow === null || flow === void 0 ? void 0 : flow.card;
  if (!card && !flow) {
    return {
      showContinueSubmission: false,
      showInsuranceIneligible: false,
      showInsuranceEligible: false,
      isAnyInsuranceTodoItemShown: false
    };
  }
  var noCard = !card;
  var isStartingFlowStage = (flow === null || flow === void 0 ? void 0 : flow.stage) === _insurance.InsuranceSubmissionFlowStageEnum.SHORTCUT_INFO;
  var isInsuranceInitializedWithoutAnySubmission = !!flow && isStartingFlowStage && noCard && !hasActiveInsurance;
  var isCurrentFlowInsuranceIneligible = isIneligibleBannerVisible(card);
  var isCurrentFlowInsuranceEigible = (card === null || card === void 0 ? void 0 : card.status) === _constants.INSURANCE_CARD_STATUSES.ELIGIBLE;
  return {
    showContinueSubmission: isInsuranceInitializedWithoutAnySubmission,
    showInsuranceIneligible: isCurrentFlowInsuranceIneligible,
    showInsuranceEligible: isCurrentFlowInsuranceEigible,
    isAnyInsuranceTodoItemShown: isInsuranceInitializedWithoutAnySubmission || isCurrentFlowInsuranceIneligible || isCurrentFlowInsuranceEigible
  };
};
exports.getInsuranceTodoItemsStatus = getInsuranceTodoItemsStatus;